export const SET_INITIAL_DASHBOARD_STATE = 'SET_INITIAL_DASHBOARD_STATE';

export const SET_DASHBOARD_PROPERTY = 'SET_DASHBOARD_PROPERTY';
